import React from 'react';
import PropTypes from 'prop-types';

import BaseVariant from './BaseVariant';
import RankCalculatorVariant from './RankCalculatorVariant';
import GoldCalculatorVariant from './GoldCalculatorVariant';

export default function ProductVariantContainer({variant, options, onChange, onCostChange}) {
  if (variant.rankCalculator) {
    return (
      <RankCalculatorVariant
        price={variant.price || 0}
        ranks={variant.rankCalculator}
        quantitySuggestions={variant.quantitySuggestions}
        options={options}
        onChange={onChange}
        onCostChange={onCostChange}
      />
    );
  }

  if (variant.goldCalculator) {
    return (
      <GoldCalculatorVariant
        price={variant.price || 0}
        calculator={variant.goldCalculator}
        quantitySuggestions={variant.quantitySuggestions}
        options={options}
        onChange={onChange}
        onCostChange={onCostChange}
      />
    );
  }

  return (
    <BaseVariant
      price={variant.price || 0}
      originalPrice={variant.originalPrice || 0}
      options={options}
      onChange={onChange}
      onCostChange={onCostChange}
    />
  );
}

ProductVariantContainer.propTypes = {
  variant: PropTypes.object.isRequired,
  options: PropTypes.array,
  onChange: PropTypes.func
};

ProductVariantContainer.describeProductChoice = product => {
  let variantOptions = [];

  if (product.variant.rankCalculator && typeof product.rankRangeStart === 'number') {
    variantOptions = [RankCalculatorVariant.describeProductChoice(product)];
  } else if (product.variant.goldCalculator) {
    variantOptions = [GoldCalculatorVariant.describeProductChoice(product)];
  }

  if (product.options) {
    variantOptions = variantOptions.concat(product.options.map(it => it.label.replace(/{[\d\-.]+?}/, '')));
  }

  return variantOptions;
};



// WEBPACK FOOTER //
// ./components/productVariants/ProductVariantContainer.js